export default "__VITE_ASSET__DcI3V$xI__"